<template>
    <app-modal v-if="active" tabindex="-1" role="dialog" @modal-close="close">
        <div
            @keydown="handleKeydown"
            class="modal__box"
        >
            <div>
                <app-heading class="modal__ttl" element="h2">Create folder</app-heading>

                <div class="px-8 my-8">
                    <input type="text" class="shadow appearance-none border rounded text-grey-darker leading-tight focus:outline-none focus:shadow-outline h-10 px-4 w-full" placeholder="Write a folder name" v-model="folderName" autofocus required>
                    <p class="my-2 text-danger" v-if="error">{{ errorMsg }}</p>
                </div>
            </div>
            <div class="modal__footer">
                <div class="flex items-center ml-auto">
                    <app-button element="button" @click.prevent="cancelCreate" class="btn btn--secondary btn--secondary--sml mr-4">Cancel</app-button>
                    <app-button element="button" ref="confirmButton" :disabled="isSaving" @click.prevent="createFolder"  class="btn btn--primary btn--primary--sml" :class="{ 'cursor-not-allowed': isSaving, 'opacity-50': isSaving }">
                        <span v-if="isSaving">Creating</span>
                        <span v-else>Create</span>
                    </app-button>
                </div>
            </div>
        </div>
    </app-modal>
</template>

<script>
import api from './api';

import Heading from '@/components/Heading';
import Modal from '@/components/Modal';
import Button from '@/components/Button';

export default {
    props: {
        active: {
            type: Boolean,
            default: false,
            required: true,
        },
        current: {
            type: String,
            default: '/',
            required: true,
        },
    },

    components: {
        'app-heading': Heading,
        'app-modal': Modal,
        'app-button': Button
    },

    data: () => ({
        folderName: null,
        error: false,
        errorMsg: '',
        showUpload: false,
        isSaving: false,
    }),

    methods: {
        /**
         * Stop propogation of input events unless it's for an escape or enter keypress
         */
        handleKeydown(e) {
            if (['Escape', 'Enter'].indexOf(e.key) !== -1) {
                return
            }

            e.stopPropagation()
        },

        close() {
            this.$emit('close')
        },

        createFolder() {
            if (this.folderName == null) {
                this.error = true;
                return false;
            }

            return api.createFolder(this.folderName, this.current).then(result => {
                this.error = false;
                this.folderName = null;
                if (result == true) {
                    this.$emit('closeCreateFolderModal', true);
                    this.$toasted.show('Folder created successfully', { type: 'success' });
                    this.$emit('refresh', true);
                } else {
                    this.error = true;
                    if (result.error) {
                        this.errorMsg = result.error;
                        this.$toasted.show('Error: ' + result.error, {
                            type: 'error',
                        });
                    } else {
                        this.errorMsg = 'The folder name is required';
                        this.$toasted.show('Error creating the folder', { type: 'error' });
                    }
                }
            });
        },

        cancelCreate() {
            this.error = false;
            this.folderName = null;
            this.$emit('closeCreateFolderModal', true);
        },
    },
};
</script>

<style>
/* Scoped Styles */
</style>



// WEBPACK FOOTER //
// src/components/filemanager/CreateFolderModal.vue